/**
 * Copyright (c) 2022 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';

import EducationView from './../views/EducationView.vue';
import GuidedScreener from './../components/GuidedScreener.vue';
import MainPage from './../components/MainPage.vue';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'home',
        component: MainPage,
        props: () => ({ testMsg: 'Welcome to the Guided Experience' }),
        children: [
            {
                path: 'screener',
                name: 'GuidedScreener',
                component: GuidedScreener
            },
            {
                path: '',
                name: 'EducationView',
                component: EducationView
            }
        ]
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 };
    }
});

export default router;
